import { requireSupabase } from "@/lib/supabaseClient";
import { guard } from "@/lib/errors";

export const reviewService = {
  forAgent: (agentId) =>
    guard("reviewService.forAgent", async () => {
      const supabase = requireSupabase();
      const { data, error } = await supabase
        .from("reviews")
        .select("*, author:profiles!reviews_author_id_fkey(full_name, avatar_url)")
        .eq("agent_id", agentId)
        .order("created_at", { ascending: false });
      if (error) throw error;
      return data || [];
    }),

  create: ({ authorId, agentId = null, propertyId = null, rating, comment }) =>
    guard("reviewService.create", async () => {
      const supabase = requireSupabase();
      const { data, error } = await supabase
        .from("reviews")
        .insert({ author_id: authorId, agent_id: agentId, property_id: propertyId, rating, comment })
        .select()
        .maybeSingle();
      if (error) throw error;
      return data;
    }),
};
